import { social } from 'settings/custom/build'
const depositBtn = social ? 'GOLD COIN PURCHASE' : 'deposit'
export const popups = {
  'error.code': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },
  'error.request.params': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  //   "error.integration.unknownError"

  // "error.integration.internalError"

  // "error.integration.timeout"

  'error.restricted-country': {
    img: 'brand/images/greyLogo.png',
    buttons: ['reload'],
    retry: false,
  },

  'error.request.bad': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'error.validation': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'error.game': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },
  'error.integration': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'error.integration.balance': {
    text: 'balanceTopUp',
    buttons: [social ? 'GOLD COIN PURCHASE' : 'deposit'],
    retry: false,
  },

  'error.integration.token': {
    text: 'sessionExpired',
    buttons: ['reload'],
    retry: false,
  },

  'error.integration.betLimit': {
    text: 'balanceLow',
    buttons: [social ? 'GOLD COIN PURCHASE' : 'deposit', 'reload'],
    retry: false,
  },

  'error.token': {
    text: 'sessionExpired',
    buttons: ['reload'],
    retry: false,
  },

  'error.server': {
    text: 'serverError',
    buttons: ['reload'],
    retry: false,
  },

  'limitExceeded': {
    buttons: ['ok'],
    text: 'limitExceeded',
    retry: false,
  },
  'sessionExpired': {
    buttons: ['reload'],
    text: 'sessionExpired',
    retry: false,
  },
  'balanceLow': {
    buttons: ['ok', 'adjust', depositBtn],
    text: social
      ? 'YOUR BALANCE IS TOO LOW TO PLACE THE SELECTED PLAY AMOUNT VALUE. PLAY AMOUNT VALUE CAN BE ADJUSTED TO THE CLOSEST AVAILABLE IN YOUR BALANCE'
      : 'balanceLow',
    retry: false,
  },
  'balanceTopUp': {
    buttons: ['ok', social ? 'GOLD COIN PURCHASE' : 'deposit'],
    text: social ? 'INSUFFICIENT COINS TO PLAY' : 'balanceTopUp',
    retry: false,
  },
  'internetConnection': {
    buttons: ['reload'],
    text: 'internetConnection',
    retry: false,
  },
  'networkError': {
    buttons: ['reload'],
    text: 'networkError',
    retry: false,
  },
  'serverError': {
    buttons: ['reload'],
    text: 'serverError',
    retry: false,
  },
  'error.integration.unknownError': {
    buttons: ['continue', 'reload'],
    text: 'serverError',
    retry: false,
  },
  'error.integration.internalError': {
    buttons: ['continue', 'reload'],
    text: 'serverError',
    retry: false,
  },
  'error.integration.timeout': {
    buttons: ['continue', 'reload'],
    text: 'serverError',
    retry: false,
  },
  'error.integration.userBlockedByExclusion': {
    buttons: [],
    text: 'BlockedByExclusion',
    retry: false,
  },
  'error.integration.maxLossLimit': {
    buttons: [],
    text: 'LossLimit',
    retry: false,
  },
  'error.integration.maxBetLimit': {
    buttons: [],
    text: social
      ? 'You have reached your self-imposed spin limit and your game session has been terminated'
      : 'BetLimit',
    retry: false,
  },
}
